<div class="fundo" role="dialog" aria-modal="true" aria-label="Desvincular conta">
  <div class="modal estreito">
    <div class="modal-cab">
      <div class="cab-ico perigo" aria-hidden="true"><svg class="i" viewBox="0 0 24 24"><path d="M9.5 14.5 7 17a3.5 3.5 0 0 1-5-5l2.5-2.5M14.5 9.5 17 7a3.5 3.5 0 0 1 5 5l-2.5 2.5M8 3v3M3 8h3M16 21v-3M21 16h-3" /></svg></div>
      <div class="cab-txt">
        <b>Desvincular conta</b>
        <span>{{ linha.hrInicio }} · {{ linha.paciente.nmPaciente }}</span>
      </div>
      <button type="button" class="btn-ico fechar-modal" title="Fechar" (click)="cancelar()" [disabled]="salvando">
        <svg class="i" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </div>

    <div class="modal-corpo">
      <ng-container *ngIf="!impedimento; else impedido">
        <p class="texto">
          O agendamento das <b>{{ linha.hrInicio }}</b> está ligado ao atendimento <b>{{ linha.paciente.nrAtendimento }}</b>.
          Desvincular limpa esse vínculo; o atendimento e a conta continuam existindo.
        </p>
        <div class="alerta warn">
          <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
          <div>Use quando a conta foi aberta no agendamento errado.</div>
        </div>
      </ng-container>
      <ng-template #impedido>
        <div class="alerta bad"><div>{{ impedimento }}</div></div>
      </ng-template>
      <div class="alerta bad" *ngIf="erro" role="alert">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
        <div>{{ erro }}</div>
      </div>
    </div>

    <div class="modal-rod">
      <button type="button" class="btn btn-contorno" (click)="cancelar()" [disabled]="salvando">Voltar</button>
      <button type="button" class="btn btn-perigo" (click)="confirmar()" [disabled]="!!impedimento || salvando">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M9 15 15 9M10 6l1.5-1.5a4.2 4.2 0 0 1 6 6L16 12M8 12l-1.5 1.5a4.2 4.2 0 0 0 6 6L14 18" /></svg>
        {{ salvando ? 'Desvinculando...' : 'Desvincular' }}
      </button>
    </div>
  </div>
</div>
